<template>

  <div :class="rootClass" id="top" :style="{paddingLeft: elementWidth}">
    <notifications />    
    <div v-if="isLoggedIn">
      <side-bar></side-bar>
      <top-bar></top-bar>
    </div>
    <article class="content">
      <transition>
        <div id="loading" v-if="showLoading">
          <font-awesome-icon icon="circle-notch" class="fa-spin spinner" />
        </div>
      </transition>
      <transition name="zoom">
        <router-view :key="$route.fullPath" />
      </transition>
    </article>
  </div>

</template>

<script>

import Side from './components/Layout/Side.vue'
import TopBar from './components/Layout/TopBar.vue'

export default {
  name: 'App',
  components: {
    "side-bar": Side,
    "top-bar": TopBar
  },
  created: function () {
    this.refreshRootClass()
  },
  data() {
    return {
      customer: {},
      rootClass: ""
    }
  },
  watch: {
    isLoggedIn() {
      this.refreshRootClass()
    },
    isPrintLayout() {
      this.refreshRootClass()
    }
  },
  methods: {
    refreshRootClass() {
      this.rootClass = this.contentClass + " " + this.menuClass  + " " + (this.isPrintLayout ? "is-print-layout" : "")
    }
  },
  computed : {
    elementWidth()  {
      return `${this.$store.state.elementWidthValue}px`
    },
    isLoggedIn()  {
      return this.$store.state.isLoggedIn
    },
    menuClass() { return this.$store.state.sidebarOpen ? "sidebar-open" : "" },
    contentClass() {
      return this.$store.state.isLoggedIn ? "app header-fixed sidebar-fixed" : ""
    },
    isPrintLayout() {
      return this.$store.state.isPrintLayout ? "is-print-layout" : ""
    },
    user()  { return this.$store.state.user.name },
    showLoading() { return this.$store.state.showLoading }
  },

}
</script>

<style scoped>
th.icon {
  width: 30px;
}
#loading {
  position: absolute;
  top:0;
  left:0;
  bottom:0;
  right:0;
  background:rgba(0,0,0,.8);
  font-size:50px;
  text-align: center;
  z-index: 10000;
}
#loading .spinner {
  position: absolute;
  top:50vh;
  left:50%;
  margin:-25px  0 0 -25px;
  color:#fff;

}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.auth-container .auth-title {
  line-height: 70px;
}

</style>
<style >
  ul{
    list-style-type: none;
  }
.reportSize  section>div{
   height: 100%;
}
.reportSize  section>div>div{
   height: 100%;
}
#sankey{
  height: 100%;
}
#sankey .card-body{
  height: 100%;
}
.sankeyChart{
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue